<template>
  <div id="app">
    <Menu />
    <carrusel />
    <quienes />
    <filosofia />
    <inspeccion />
    <asesoria />
    <administracion />
    <galeria />
    <FooterPage />
  </div>
</template>

<script>
import Menu from "@/components/nav.vue";
import Carrusel from "@/components/carrusel.vue";
import Quienes from "@/components/quienes.vue";
import Filosofia from "@/components/filosofia.vue";
import Inspeccion from "@/components/inspeccion.vue";
import Asesoria from "@/components/asesoria.vue";
import Galeria from "@/components/galeria.vue";
import Administracion from "@/components/administracion.vue";
import FooterPage from "@/components/FooterPage.vue";

const WOW = require("wow.js/dist/wow.js");
let wow = new WOW();

export default {
  name: "app",
  components: {
    Menu,
    Carrusel,
    Quienes,
    Filosofia,
    Inspeccion,
    Asesoria,
    Administracion,
    Galeria,
    FooterPage
  },
  mounted() {
    wow.init();
  }
};
</script>
